var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"ts-relative"},'div',_vm.$attrs,false),[_c('gmap-autocomplete',{staticClass:"form-control",staticStyle:{"z-index":"1021"},attrs:{"value":_vm.value,"placeholder":_vm.$t('typeYourLocation'),"select-first-on-enter":true,"options":{
      bounds: {
        north: 12.665678999999999,
        south: 12.465679,
        east: 105.09096699999999,
        west: 104.890967
      },
      fields: ['geometry', 'name']
    }},on:{"place_changed":_vm.setPlace}},[_vm._v("\n    >\n  ")]),_c('span',{staticClass:"ts-absolute ts-top-0 ts-mt-1 ts-right-0 ts-text-blue-600 ts-cursor-pointer",on:{"click":_vm.getCurrentGeoLocation}},[_c('i',{staticClass:"fas fa-street-view fa-2x"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }